import { motion } from "framer-motion";
import Container from "../../components/ui/container";
import { Card, CardContent } from "../../components/ui/card";
import Consultation from "../../../public/consultation.jpg"

const steps = [
  {
    title: "Schedule a Consultation",
    description: "Schedule a consultation call with our client success team to learn more about our assistants, share your needs, get personalized recommendations, and get started with remote support.",
    image: "https://img.freepik.com/free-vector/business-team-discussing-ideas-startup_74855-4380.jpg"
  },
  {
    title: "Get Matched",
    description: "Complete a matching survey, and we'll match you with your assistant in no time! We match assistants based on task expertise, industry fit, and shared working style preferences.",
    image: "https://img.freepik.com/free-vector/recruitment-agency-searching-job-candidate_1262-19873.jpg"
  },
  {
    title: "Start Delegating",
    description: "Once you are matched with an assistant, you can start delegating tasks or projects. You can share new requests with your assistant and schedule weekly check-in meetings.",
    image: "https://img.freepik.com/free-vector/team-leader-managing-project_1262-21430.jpg"
  }
];

export default function Steps() {
  return (
    <section className="py-20 bg-gray-50">
      <Container>
        <div className="text-center max-w-2xl mx-auto mb-12">
          <motion.h2 
            className="text-3xl font-bold"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Get started in 3 easy steps
          </motion.h2>
          <motion.p 
            className="mt-4 text-gray-600"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            Simple set up. Immediate impact. Take a closer look at how our virtual assistants get started with you.
          </motion.p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="h-full hover:shadow-lg transition-shadow overflow-hidden">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-48 object-cover"
                />
                <CardContent className="pt-6">
                  <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}
